export const RESET = 'SQLSCRIPTEXECUTED_UPDATE_RESET'
export const SET_ERROR = 'SQLSCRIPTEXECUTED_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'SQLSCRIPTEXECUTED_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'SQLSCRIPTEXECUTED_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'SQLSCRIPTEXECUTED_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'SQLSCRIPTEXECUTED_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'SQLSCRIPTEXECUTED_UPDATE_UPDATE_RETRIEVED'
